module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"WBSAllocationMethods\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-allocation-methods/wbs-allocation-methods.component.html
// module id = ./src/app/wbs-allocation-methods/wbs-allocation-methods.component.html
// module chunks = main